/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heartbeat_Session_LostInputs */

const en_heartbeat_session_lost = /** @type {(inputs: Heartbeat_Session_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your session was terminated by the server. You can start a new one.`)
};

const fr_heartbeat_session_lost = /** @type {(inputs: Heartbeat_Session_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre session a été terminée par le serveur. Vous pouvez en démarrer une nouvelle.`)
};

const ms_sg2_heartbeat_session_lost = /** @type {(inputs: Heartbeat_Session_LostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi anda telah ditamatkan oleh pelayan. Anda boleh memulakan yang baru.`)
};

/**
* | output |
* | --- |
* | "Your session was terminated by the server. You can start a new one." |
*
* @param {Heartbeat_Session_LostInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const heartbeat_session_lost = /** @type {((inputs?: Heartbeat_Session_LostInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heartbeat_Session_LostInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_heartbeat_session_lost(inputs)
	if (locale === "fr") return fr_heartbeat_session_lost(inputs)
	return ms_sg2_heartbeat_session_lost(inputs)
});